angular.module('picmonicng').factory('FactsResource', [
  '$resource',
  function ($resource) {
    return $resource(
      '/api/v2/facts/:fact_id/:resource',
      {
        fact_id: '@fact_id',
        resource: '@resource',
        resource_id: '@resource_id',
      },
      {
        queryv3: {
          method: 'GET',
          url: '/api/v3/facts/:fact_id/:resource/:resource_id',
          isArray: true,
        },
        getv3: {
          method: 'GET',
          url: '/api/v3/facts/:fact_id/:resource/:resource_id',
          isArray: false,
        },
        update: { method: 'PUT', isArray: false },
        updatev3: {
          method: 'PUT',
          url: '/api/v3/facts/:fact_id/:resource/:resource_id',
        },
        savev3: {
          method: 'POST',
          url: '/api/v3/facts/:fact_id/:resource/:resource_id',
        },
        deletev3: {
          method: 'DELETE',
          url: '/api/v3/facts/:fact_id/:resource/:resource_id',
        },
        delete: {
          method: 'DELETE',
          url: '/api/v2/picmonics/:card_id/facts/:fact_id/',
        },
      }
    );
  },
]);
